import { useQuery } from "react-query";
import MapDataWithSum from "../models/interfaces/dtos/map-data-with-sum-dto";
import {fetchItem} from "../queries/queries-helper.ts";
import ENDPOINTS from "../services/endpoints.ts";

const useMapData = (localisationId: number, startDate: Date, endDate: Date, dataOption: string) => {
    const isoStartDate = startDate.toISOString();
    const isoEndDate = endDate.toISOString();

    return useQuery<MapDataWithSum[]>(
        ["map-data", localisationId, isoStartDate, isoEndDate, dataOption],
        async () => {
            const data = await fetchItem<MapDataWithSum[]>(ENDPOINTS.SURFACE_PROCESSED_MAP_DATA(localisationId, isoStartDate, isoEndDate, dataOption));
            return data ?? [];
        },
        {
            enabled: !!localisationId && !!startDate && !!endDate && (!!dataOption && (dataOption === "SHAB" || dataOption === "SHO")),
            staleTime: 60 * 60 * 1000 // 1 heure
        }
    );
};

export default useMapData;
